import { isAppRunningInLowerEnvironment } from 'shared/Helpers/Utils';
import './UserValidationHelper';
import Cookies from 'js-cookie';

const getValidValueOf = (inputValCheck, successValue, defaultValue='') =>
{
    return inputValCheck ? successValue : defaultValue
}

const getValidValue = (strValue,defaultValue='') =>
{
    return strValue ? strValue : defaultValue
}

const isValidValue = (inputVal) => {

    return inputVal ? true : false
}


const isRoleNotGuestAndProspect = (role) => {
    return role !== 'Guest' && role !== 'Prospect'
}
const isHaveSpouse = (arrayData,findOutValue) =>
{
    const filterData = arrayData?.filter((item)=> item?.relationToAccHolder == findOutValue);
    return filterData?.length > 0 ? true : false;
}

const getDataFromANDCondition = (value1,value2,value3="") =>
{
    if(value3 =="")
    {
        return (value1 && value2);
    }
    else
    {
        return (value1 && value2 && value3);
    }
}

const checkORConditionWithParameter = (value1,value2,value3,value4) =>
{
    return (value1 == value2 || value3 == value4)
}

const checkANDConditionWithParameter = (value1,value2,value3,value4) =>
{
    return (value1 == value2 && value3 == value4)
}

const accountIdentification = (dataObj,accountType) =>
{
   return (dataObj?.getEnabledFeature?.features == undefined) ? false : dataObj.getEnabledFeature?.features.includes(accountType);
}


const accountIdentificationBasedOnPortfolioSummary = (portfolioSummaryObj, accountType) => {
    if (accountType === 'Brokerage') {
        const brokerageAccounts = portfolioSummaryObj?.accountSummary?.accountDetails?.brokerage?.accounts;
        return Array.isArray(brokerageAccounts) && brokerageAccounts.length > 0;
    }
    return true;
}

const isOldDashbord = (dataObj,accountType) =>
{
   return (dataObj?.getEnabledFeature?.features !== undefined && !dataObj.getEnabledFeature?.features.includes(accountType));
}

const getDataFromThreeOrCondition = (value1,value2,value3) =>
{
    return (value1 || value2 || value3);
}


const getDataFromTwoOrCondition = (value1,value2) =>
{
    return (value1 || value2);
}

const checkSingleEqualityAndReturnValue = (op1,op2,returnValue1,returnValue2)=>
{
    return (op1==op2 ? returnValue1 : returnValue2);
}

const checkArrayLengthAndReturnValue = (arrayData,lengthValue,value1,value2)=>
{
    return (arrayData?.length > lengthValue ? value1 : value2)
}

const identifyIsProportionate =(arrayObj)=>{
    const filterArray = arrayObj.filter((item)=> item?.showProportionate == true)
    return filterArray?.length > 0 ? true : false;
}

const identifyIsProportionateFundAvailable =(arrayObj)=>{
    if(arrayObj.length > 0){
        const isProportionateFundAvailable = arrayObj.some(item=> item.fundName === 'Proportionate' && item?.showProportionate )
        return !isProportionateFundAvailable;
    }
   
    return false
}

const identifyExsitingAccount =(arrayObj)=>{
    let count = 0;
    let tempArrayobj = JSON.parse(JSON.stringify(arrayObj));
    for(let i=0; i<tempArrayobj.length; i++){
        if(tempArrayobj[i]?.fundAccountNumber){
            count++;
        }
    }
    if(count > 1){
        return true
    }
    else{
       return false
    }
}
const addNewElementIntoArray = (arrayObj)=>{
    let index =0;
    let tempArrayobj = JSON.parse(JSON.stringify(arrayObj));
    if(identifyExsitingAccount(tempArrayobj) && identifyIsProportionate(tempArrayobj)== false ){
        for(let i=0; i<tempArrayobj.length; i++){
            if(tempArrayobj[i]?.fundAccountNumber){
                index = i;
            }
        }
        tempArrayobj.splice(index+1,0,{showProportionate:true,fundName:'Proportionate',
        fundOptionSelected:"sub",
        minimumAutomaticInvestment:"50.000000000000"
        })
        return tempArrayobj
    }
    return tempArrayobj
}

const addNewElementIntoSellFunds =(arrayObj)=>{
    let tempArrayobj = JSON.parse(JSON.stringify(arrayObj));
    if(tempArrayobj?.length > 1 && identifyIsProportionate(tempArrayobj)== false){
        tempArrayobj.push({showProportionate:true,fundName:'Proportionate',
        userinputamt:"",
        liquidityNoticeFlag:false,
        redemptionNoticeFlag:false,
        fundNumber:"ProportionateFund",
        accountType:"",
        accountValue:"",
        availableShares:"",
        changeInNav:"",
        changeInNavPercentage:"",
        costBasis:"Average",
        currentAccountBalance:"",
        eschowShare:"",
        fundAccountNumber:"",
        fundType: "Target Retirement",
        imposedFee:"NA",
        initialInvestment:"",
        lastNav:"",
        max52W:"",
        min52W:"",
        minimumAutomaticInvestment:"",
        minimumInitialAnnuallyInvestment:"",
        minimumInitialBiweeklyInvestment:"",
        minimumInitialMonthlyInvestment:"",
        minimumInitialQuarterlyInvestment:"",
        nav:"",
        netAsset:"",
        pendShrTot:"",
        risk:"Moderate",
        socialCode:"1",
        symbol: "URTRX",
        unissShrBal: "",
        unissuedBalance: "",
        unissuedShares: "",
        amtType: ""
        })
    }
    return tempArrayobj
}


const removeProportionateFund = (arrayObj) =>{
    let tempArrayobj = JSON.parse(JSON.stringify(arrayObj));

    if(identifyIsProportionate(tempArrayobj))
    {
        tempArrayobj.pop();
        console.log('tempArrayobj',tempArrayobj)
        return tempArrayobj;
    }

    return tempArrayobj;
}


const identifyExsitingAccountWithInitialInvestment = (obj,fundOptionSelected) =>{

    if(obj?.fundAccountNumber == undefined && fundOptionSelected == 'init')
    {
        return true;
    }
    else
    {
        return false;
    }
}

const setTokenCookie = (token, expiryEpochSeconds) => {
    console.log('expiryEpochSeconds common',expiryEpochSeconds)
    // Input validation
    if (!token || typeof token !== 'string') {
        return false;
    }

    // Parse and validate expiry
    const expiryEpochSecondsNum = parseInt(expiryEpochSeconds, 10);
    if (isNaN(expiryEpochSecondsNum) || expiryEpochSecondsNum <= 0) {
        console.warn('Invalid expiryEpochSeconds provided');
        return false;
    }

    const currentTime = Math.floor(Date.now() / 1000);
    const maxAge = expiryEpochSecondsNum - currentTime;
    
    // Don't set expired cookies
    if (maxAge <= 0) {
        console.warn('Token is already expired');
        return false;
    }

    // Get current values for comparison
    const currentToken = Cookies.get("formsToken");
    const currentExpiryCookie = Cookies.get("formsToken_exp");
    
    // Only update if values have changed (string comparison for consistency)
    if (currentToken === token && currentExpiryCookie === expiryEpochSeconds.toString()) {
        return false;
    }

    // Cookie configuration optimized for cross-subdomain usage
    const cookieOptions = {
        path: "/",
        domain: ".vcm.com",
        secure: true,
        sameSite: "Lax", // Changed from "None" for better security
        expires: new Date(expiryEpochSecondsNum * 1000) // Direct expiry calculation
    };
    
    try {
        // Set both token and expiry in cookies for cross-app consistency
        Cookies.set("formsToken", token, cookieOptions);
        Cookies.set("formsToken_exp", expiryEpochSeconds.toString(), cookieOptions);

        
        return true;
    } catch (error) {
        console.error('Failed to set token cookie:', error);
        return false;
    }
};


const getAEMFormLink =(formID)=>{
  let link="";  
  switch(formID)
  {
      case "99467":
        link= "tools-resources/forms/gifting-of-securities-form";
        break;
      case "98146":
        link = "tools-resources/forms/transfer_on_deathregister";
        break;
      case "99471":
        link = "tools-resources/forms/ira-beneficiary-form";
        break;
      case "15360":
        link= "tools-resources/forms/registration-change";
        break;
      case "99267":
        link="tools-resources/forms/non-retirement-application-form";
        break;
      default:
        link=""
  }
  return link;
}

export {
    getValidValueOf,
    getValidValue,
    isValidValue,
    isRoleNotGuestAndProspect,
    getDataFromANDCondition,
    checkORConditionWithParameter,
    checkANDConditionWithParameter,
    accountIdentification,
    accountIdentificationBasedOnPortfolioSummary,
    isOldDashbord,
    getDataFromThreeOrCondition,
    checkSingleEqualityAndReturnValue,
    checkArrayLengthAndReturnValue,
    isHaveSpouse,
    addNewElementIntoArray,
    identifyIsProportionate,
    identifyExsitingAccount,
    addNewElementIntoSellFunds,
    identifyIsProportionateFundAvailable,
    removeProportionateFund,
    identifyExsitingAccountWithInitialInvestment,
    getAEMFormLink,
    setTokenCookie,
    getDataFromTwoOrCondition
}